import { format } from "date-fns";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import loadingGreen from "../../images/loading_gray.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { formatMoney } from "../../utils/numbers";
import { USER_ROUTES } from "../../utils/routeConstants";
import { getErrorValue } from "../BillingScreen/BillingScreen";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { ConfirmationModalThird } from "../ConfirmationModal/ConfirmationModalThird";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Modal from "../Modal/Modal";
import QuotationErrors from "../QuotationErrors/QuotationErrors";
import {
  Container,
  MainButton,
  Row,
  RowContainer,
} from "./QuotationConfirmationStyles";

interface IQuotations {
  document_number: string;
  dam_num: string;
  volantes: {
    volante_num: string;
    additional_services: any[];
    billable_ruc_option: string;
    withdrawal_date: string;
  }[];
}

function QuotationConfirmation(props) {
  const {
    volantes,
    damId,
    dateRucStatus,
    toggleModal,
    dni,
    updateShowModalClose,
    userInfo,
    refreshBilling,
  } = props;

  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [useDollars] = useContext(CurrencyContext);
  const [showModal, updateShowModal] = useState(false);
  const [showQuotationErrors, updateShowQuotationErrors] = useState(false);
  const [failedVolantes] = useState<any>(false);
  const [error, setError] = useState("");
  const onConfirm = () => {
    if (waitingServerResponse) return;

    updateWaitingServerResponse(true);

    const body: IQuotations = {
      document_number: dni,
      dam_num: damId,
      volantes: (
        volantes as {
          id: string;
          additional_services: any;
          withdrawal_date: Date;
        }[]
      ).map((volante) => {
        const formatedDate = format(volante.withdrawal_date, "yyyy-MM-dd");
        return {
          volante_num: volante.id,
          additional_services: volante.additional_services,
          billable_ruc_option: dateRucStatus[volante.id].billableRuc,
          withdrawal_date: formatedDate,
        };
      }),
    };
    // Returns the status of each promise: fullfilled or rejected.
    networkBackendRequest(`/quotations/`, HTTP_METHODS.POST, {}, body)
      .then((resp) => resp.json())
      .then(() => {
        updateWaitingServerResponse(false);
        updateShowModal(true);
      })
      .catch((e) => {
        setError(getErrorValue(e));
        updateWaitingServerResponse(false);
      });
  };

  const onClose = () => {
    toggleModal();
  };

  const toggleQuotationErrorsModal = () => {
    updateShowQuotationErrors(!showQuotationErrors);
  };

  const toggleConfirmationModal = () => {
    updateShowModal(!showModal);
  };
  const history = useHistory();

  return (
    <>
      <Modal onOutsideClick={onClose}>
        <Container>
          <h1>Confirmación de prefactura</h1>
          <h2>Se generará la prefactura para los siguientes volantes</h2>
          <RowContainer>
            {volantes.map((volante) => (
              <Row key={volante.id}>
                <div>
                  <h2>{volante.id}</h2>
                  <h3>{volante.importer}</h3>
                </div>
                <div className="price">
                  {formatMoney(dateRucStatus[volante.id].amount, useDollars)}
                </div>
              </Row>
            ))}
          </RowContainer>
          <MainButton disabled={waitingServerResponse} onClick={onConfirm}>
            {waitingServerResponse && (
              <img
                src={loadingGreen}
                width="50"
                height="50"
                alt="Processing request"
              />
            )}
            Confirmar prefactura
          </MainButton>
        </Container>
      </Modal>
      {showQuotationErrors && (
        <QuotationErrors
          volantes={failedVolantes}
          dateRucStatus={dateRucStatus}
          toggleModal={toggleQuotationErrorsModal}
          updateShowModal={updateShowModal}
          updateShowModalClose={updateShowModalClose}
          onCloseError={onClose}
        />
      )}

      {showModal && (
        <ConfirmationModalThird
          onAccept={() => {
            if (userInfo.profile.name === "Cotizador") {
              refreshBilling();
            } else {
              history.push(USER_ROUTES.PAYMENT.path);
              toggleConfirmationModal();
            }
          }}
          title={"Prefacturas confirmadas"}
          toggleModal={() => {
            if (userInfo.profile.name === "Cotizador") {
              refreshBilling();
            } else {
              history.push(USER_ROUTES.PAYMENT.path);
              toggleConfirmationModal();
            }
          }}
          buttonTitle={"Entendido"}
          backgroundColor={"#002E6C"}
        >
          <p>
            Sus prefacturas han sido confirmadas. Recordar que tiene el{" "}
            <b style={{ color: "#2E353D" }}>día de hoy</b> para realizar el
            pago.
          </p>
        </ConfirmationModalThird>
      )}
      {error && (
        <ConfirmationModal
          title={"Atención"}
          toggleModal={() => {
            setError("");
          }}
          onAccept={() => {
            setError("");
          }}
          message={error}
        />
      )}
    </>
  );
}

export default QuotationConfirmation;
